import { Injectable, signal } from '@angular/core';
import { CookieService } from 'lib/cookies/cookie.service.js';
import { PlatformService } from 'lib/platform/index.js';
import { AppTheme } from './app-themes.js';

@Injectable({
	providedIn: 'root'
})
export class ThemeService {
	public readonly theme = signal<AppTheme>('light');
	public readonly themeCookieName: string = `app-theme`;

	constructor(private readonly platformService: PlatformService, private readonly cookieService: CookieService) {}

	setTheme(theme: AppTheme): void {
		if (this.platformService.isServer) {
			return;
		}

		const htmlTagDataset = document.getElementsByTagName('html')?.[0]?.dataset;
		htmlTagDataset['theme'] = theme;
		this.setThemeCookie(theme);
		this.theme.set(theme);
	}

	/**
	 * Call this once in root component
	 */
	initTheme(): void {
		const cookieTheme = this.getThemeFromCookie();

		if (cookieTheme) {
			this.setTheme(cookieTheme);
			return;
		}

		if (this.platformService.isServer) {
			return;
		}
		const htmlTagDataset = document.getElementsByTagName('html')?.[0]?.dataset;

		if (htmlTagDataset) {
			const theme = this.mapTextToTheme(htmlTagDataset['theme']);
			if (theme === 'dark') {
				this.setTheme('dark');
			} else {
				this.setTheme('light');
			}
		}
	}

	private getThemeFromCookie(): AppTheme | undefined {
		const themeCookie = this.cookieService.getCookie('Theme');

		if (!themeCookie) {
			return undefined;
		}

		return this.mapTextToTheme(themeCookie);
	}

	private setThemeCookie(theme: AppTheme): void {
		this.cookieService.setCookie('Theme', theme, {
			expiresInDays: 365
		});
	}

	private mapTextToTheme(text?: string): AppTheme {
		if (text?.toLowerCase() === 'dark') {
			return 'dark';
		}
		return 'light';
	}
}
